<template>
    <section class="">
        <div class="box">
            <section class="hero">
                <div class="hero-body">
                    <p class="title">
                        {{ $t('account.register.verified') }}
                    </p>
                    <p class="subtitle">
                        {{ $t('account.register.can_log_in') }}
                    </p>
                </div>
            </section>

            <section class="section">
                <div class="buttons">
                    <b-button
                        tag="router-link"
                        to="/login"
                        type="is-primary"
                        @click.prevent="doLogin"
                        >{{ $t('account.register.log_in') }}
                    </b-button>
                </div>
            </section>
        </div>
    </section>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'Login',
    data() {
        return {
            loading: false,
            email: null,
            password: null
        }
    },
    methods: {
        ...mapActions('auth', ['login']),
        doLogin() {
            this.loading = true

            if (this.email && this.password) {
                this.login({ email: this.email, password: this.password })
                    .then(() => {
                        this.$router.push('/')
                    })
                    .catch((e) => {
                        this.$store.dispatch('toastError', e)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        }
    }
}
</script>

<style scoped></style>
